import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import FormikInput from 'components/input/formik-input';
import { AxisIcon } from '../../../../../assets/concrete-structural-elements/';
import { ConcreteOrientation } from '../../../types';
import {
  ContentWrapper,
  InputsWrapper,
  StyledAxisIcon,
  Wrapper,
} from './styles';
import { RequiredAxisDistanceDisclaimer } from '../../../../../components/disclaimer-with-background/required-axis-distance-disclaimer';

interface AxisInformationInputsProps {
  allStructures: ConcreteOrientation[];
  selectedStructureId: number;
}

const AxisInformationInputs = ({
  allStructures,
  selectedStructureId,
}: AxisInformationInputsProps) => {
  const { t } = useTranslation();

  const [selectedStructureName, setSelectedStructureName] = useState(
    allStructures.filter((x) => x.id === selectedStructureId)[0].name
  );

  useEffect(() => {
    setSelectedStructureName(
      allStructures.filter((x) => x.id === selectedStructureId)[0].name
    );
  }, [selectedStructureId]);

  return (
    <ContentWrapper>
      <Wrapper>
        <StyledAxisIcon src={AxisIcon} />
        <InputsWrapper>
          <FormikInput
            name="currentAxis"
            label={t('concrete.structuralElements.currentAxis') ?? ''}
            placeholder={t('concrete.structuralElements.axisPlaceholder') ?? ''}
            numberInput
            maxLength={5}
            optional
            tooltipText={t('concrete.structuralElements.tooltipText') ?? ''}
          />
          <FormikInput
            name="requiredAxis"
            label={
              t(
                'concrete.structuralElements.requiredAxis'
              ) ?? ''
            }
            placeholder={t('concrete.structuralElements.axisPlaceholder') ?? ''}
            numberInput
            maxLength={5}
          />
        </InputsWrapper>
      </Wrapper>
      <RequiredAxisDistanceDisclaimer selectedStructureName={selectedStructureName}/>
    </ContentWrapper>
  );
};

export default AxisInformationInputs;
